import { Tab, TabList, TabPanels, Tabs, TabPanel } from '@chakra-ui/tabs';
import { Grid } from '@chakra-ui/react';
import { StarberryComponentContext, useModuleDefinition } from '@starberry/components';
import React, { useCallback, useContext, useEffect, useState } from 'react';

const SimpleTabs = ({
  tabs = [],
  tabProps,
  tabListProps,
  tabPanelProps,
  tabPanelsProps,
  sidecontent,
  onChange,
  ...props
}) => {
  const { theme, constants } = useContext(StarberryComponentContext);
  const SideContent = useModuleDefinition(sidecontent);
  const [selectedTab, setSelectedTab] = useState(0);

  useEffect(() => {
    if (window.location.hash !== '') {
      const tab = tabs.findIndex(({ id }) => id === window.location.hash.substr(1));
      if (tab >= 0) {
        setSelectedTab(tab);
      }
    }
  }, [tabs]);

  const handleChangeTab = useCallback(
    (index) => {
      if (tabs[index].id) {
        window.history.pushState({}, window.title, `#${tabs[index].id}`);
      }
      setSelectedTab(index);
      onChange?.(index);
    },
    [tabs, onChange, setSelectedTab]
  );

  return (
    <Tabs index={selectedTab} {...props} onChange={handleChangeTab}>
      <TabList px={theme.space[12]} borderBottomWidth={1} borderColor={'#d8d8d8'} {...tabListProps}>
        {tabs.map(({ title }) => (
          <Tab
            px={0}
            mr={10}
            color={constants.colors.text}
            fontSize={[constants.body.bodySize.small, null, null, constants.body.bodySize.large]}
            pb={[2, null, 7]}
            borderBottomWidth={'3px'}
            _focus={{ boxShadow: 'none' }}
            _active={{ bg: 'none' }}
            _selected={{
              color: constants.colors.primary,
              borderColor: constants.colors.primary,
              fontWeight: theme.fontWeights.bold
            }}
            {...tabProps}
          >
            {title}
          </Tab>
        ))}
      </TabList>
      <Grid
        alignItems="start"
        templateColumns={{ base: '1fr', md: sidecontent ? '2fr 1fr' : '1fr' }}
      >
        <TabPanels px={theme.space[12]} pt={[10, null, 14]} {...tabPanelsProps}>
          {tabs.map(({ content }) => {
            const Content = useModuleDefinition(content);
            if (!Content) {
              return null;
            }
            return (
              <TabPanel p={0} {...tabPanelProps}>
                <Content />
              </TabPanel>
            );
          })}
        </TabPanels>
        {SideContent && <SideContent />}
      </Grid>
    </Tabs>
  );
};

export default SimpleTabs;
